import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import VerbSelect from '../../../../shared/components/formComponents/inputs/VerbSelect';

const SHOW_COMPLETED_PATHWAYS = 'Show completed pathways';
const HIDE_COMPLETED_PATHWAYS = 'Hide completed pathways';

const formatOptionLabel = ({ name, isCompleted, teamId = null, pastTeamId = null }) =>
    [SHOW_COMPLETED_PATHWAYS, HIDE_COMPLETED_PATHWAYS].includes(name) ? (
        <div style={{ textAlign: 'center', width: '100%' }}>
            <div className={'pathway-show-completed'}>{name}</div>
        </div>
    ) : (
        <div className={'d-flex h-100'}>
            {teamId || pastTeamId ? (
                <OverlayTrigger
                    trigger={['hover', 'focus']}
                    key={'right'}
                    placement={'right'}
                    overlay={
                        <Tooltip id={`tooltip-right`}>{`This pathway ${
                            teamId && !pastTeamId ? 'is' : 'was'
                        } assigned to one of your teams`}</Tooltip>
                    }
                >
                    <i className={`col-1 my-auto fal fa-user-friends fa-lg pathway-team-individual-icon`} />
                </OverlayTrigger>
            ) : (
                <OverlayTrigger
                    trigger={['hover', 'focus']}
                    key={'right'}
                    placement={'right'}
                    overlay={<Tooltip id={`tooltip-right`}>You're doing this pathway as an individual</Tooltip>}
                >
                    <i className={`col-1 my-auto fal fa-user-alt fa-lg pathway-team-individual-icon`} />
                </OverlayTrigger>
            )}
            <div className={'col-8 pathway-select-item'}>{name}</div>
            {isCompleted ? (
                <i className={`col-1 my-auto fad fa-badge-check color-pink fa-lg pathway-completed-icon`} />
            ) : null}
        </div>
    );

const MyPathwaySelect = ({
    setSelectOptions,
    setToDefaultPathway,
    handleShowCompletedPathways,
    handlePathwaySelect,
    pathwayOptionsForSelect,
    selectOptions,
    pathwayToDisplay
}) => (
    <VerbSelect
        className={'my-pathway-select'}
        value={pathwayToDisplay._id}
        labelKey={'name'}
        valueKey={'_id'}
        onChange={handlePathwaySelect}
        options={pathwayOptionsForSelect}
        formatOptionLabel={formatOptionLabel}
        selectOptions={selectOptions}
        onBlur={() => {
            setSelectOptions({});
            setToDefaultPathway({ pathway: pathwayToDisplay, hidePathways: true });
            handleShowCompletedPathways(false, pathwayToDisplay);
        }}
    />
);

formatOptionLabel.propTypes = {
    name: PropTypes.string,
    isCompleted: PropTypes.bool,
    teamId: PropTypes.string,
    pastTeamId: PropTypes.string
};

MyPathwaySelect.propTypes = {
    setSelectOptions: PropTypes.func,
    setToDefaultPathway: PropTypes.func,
    handleShowCompletedPathways: PropTypes.func,
    handlePathwaySelect: PropTypes.func,
    pathwayOptionsForSelect: PropTypes.array,
    selectOptions: PropTypes.object,
    pathwayToDisplay: PropTypes.object
};

export default MyPathwaySelect;
